import { render } from "./NoticeRead.vue?vue&type=template&id=64c8fc26"
import script from "./NoticeRead.vue?vue&type=script&lang=js"
export * from "./NoticeRead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__